import PlanBenefitsStep from "components/steps/PlanBenefitsStep";

const Step4Pages = () => <PlanBenefitsStep />;

export default Step4Pages;
